module.exports = __webpack_public_path__ + "static/media/348FF357-79EF-40FD-9215-F49EC899A2CE.d62040fd.bin";